import React from 'react';
import WifiMetricMiniCard from './WifiMetricMiniCard';
import { Skeleton } from '../../util/skeleton/Skeleton';
import { numberFormat } from '../../util/araknerdlib';

const toGB = (bytes) => (bytes ? bytes / (1024 ** 3) : 0);

const WifiMetricsRow = ({ trafficUsage }) => {
  const loading = !trafficUsage; // server sends null initially

  // Derive values safely
  const totalDevices = loading ? 0 : Number(trafficUsage.total_macs || 0);
  const totalSessions = loading ? 0 : Number(trafficUsage.total_paid || 0);

  // Prefer server-provided GB, else compute from bytes
  const dataGBVal = loading
    ? 0
    : (typeof trafficUsage.total_data_gb === 'number'
        ? trafficUsage.total_data_gb
        : toGB(trafficUsage.total_data || 0));

  const dataGB = `${dataGBVal.toFixed(2)} GB`;

  return (
    <div className="d-flex justify-content-end align-items-center py-3 px-4 rounded">
      {/* Total Devices */}
      {loading ? (
        <div style={{ minWidth: 220 }}>
          <Skeleton w="120px" h={12} />
          <div style={{ height: 6 }} />
          <Skeleton w="100px" h={24} />
        </div>
      ) : (
        <WifiMetricMiniCard
          label="Total Devices"
          value={numberFormat(totalDevices)}
          iconColor="text-success"
          icon="fas fa-users"
        />
      )}

      <div className="border-left mx-3" style={{ height: 30 }} />

      {/* Total Data Usage */}
      {loading ? (
        <div style={{ minWidth: 220 }}>
          <Skeleton w="150px" h={12} />
          <div style={{ height: 6 }} />
          <Skeleton w="96px" h={24} />
        </div>
      ) : (
        <WifiMetricMiniCard
          label="Total Data Usage"
          value={dataGB}
          iconColor="text-primary"
          icon="fas fa-database"
        />
      )}

      <div className="border-left mx-3" style={{ height: 30 }} />

      {/* Total Sessions = total_paid */}
      {loading ? (
        <div style={{ minWidth: 220 }}>
          <Skeleton w="120px" h={12} />
          <div style={{ height: 6 }} />
          <Skeleton w="110px" h={24} />
        </div>
      ) : (
        <WifiMetricMiniCard
          label="Total Sessions"
          value={numberFormat(totalSessions)}
          iconColor="text-warning"
          icon="fas fa-plug"
        />
      )}
    </div>
  );
};

export default WifiMetricsRow;
